import React, { Component } from "react";
import Routes from "./Route.js";
import { Auth } from "aws-amplify";
import store from "./store/index";
import {updateTimeSettings} from "./actions/index";
import { updateFilteredCountryList } from "./actions/index";
import { updateExactTimeSettingsOneByOne } from "./actions/index";
import {update_Is_Exact_Time_One_By_One} from "./actions/index";
import {updateT0Settings} from "./actions/index";
import {update_Steamer_Drifter_Settings} from "./actions/index";
import {updateLocalTimeOffSetToGmt} from "./actions/index";
import {updateLocalTimeZone} from "./actions/index";
import {updateLatestOddsSettings} from "./actions/index";
import { updateTimeSettingsOneByOne, updateCommissionSetting, updateBackStakeSetting, updateLayStakeSetting } from "./actions/index";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

class App extends Component {

  constructor(props) {
  super(props);

  this.state = {
    isAuthenticated: false,
    isAuthenticating: true,
    userName:""
  };

}

// async initializeUserInfo(){
// try {
// const info = await Auth.currentUserInfo()
// console.log('Returned info:: ', info)
// this.setState({
//   userInfo:info.attributes.email
// })
// }catch (e) {
// console.log("Error");
// //alert(e.message);
// }
// }

//convertMinutesToLocalTimeZone = num =>
//{ 
//  let sign = "+";
//  if(num < 0) sign = "-"
//  num = Math.abs(num);
//  const hours = Math.floor(num / 60);  
//  const minutes = num % 60;
//  return  "GMT" + sign + (hours < 10  ? "0" + hours : hours)  + ":" + (minutes < 10  ? "0" + minutes : minutes) ;         
//}

async componentDidMount() {
  try {
    await Auth.currentSession();

    const user =  await Auth.currentAuthenticatedUser();
    const userGroups = user.signInUserSession.accessToken.payload["cognito:groups"];
    if(userGroups === undefined || !userGroups.includes("racing-price-monitor-user")) {
        throw new Error("You don't have access to this application. Please contact site administrator.");
    }
    

    try {
    this.userHasAuthenticated(true);
    const info = await Auth.currentUserInfo()
    console.log('Returned info:: ', info)

    //const offset = new Date().getTimezoneOffset() * -1;
    //const timezone = this.convertMinutesToLocalTimeZone(offset);
    //console.log("timezone offset: " + offset + ", timezone: " + timezone);
    //store.dispatch(updateLocalTimeOffSetToGmt(offset));
    //store.dispatch(updateLocalTimeZone(timezone));

    let filteredCountryList = info.attributes["custom:filteredCountryList"]
    var Arr = filteredCountryList.split(',');
    store.dispatch(updateFilteredCountryList(Arr))
    //console.log('Returned info:: ', filteredCountryList)

    let payload={}
    payload.id = "t1"
    payload.value = info.attributes["custom:t1"]
    store.dispatch(updateTimeSettingsOneByOne(payload))

    payload.id = "t2"
    payload.value = info.attributes["custom:t2"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t3"
    payload.value = info.attributes["custom:t3"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t4"
    payload.value = info.attributes["custom:t4"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t5"
    payload.value = info.attributes["custom:t5"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t6"
    payload.value = info.attributes["custom:t6"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

  
  let customT0Diff = (info.attributes["custom:t0"].split("|")[0]).split(",")
  if(customT0Diff.length > 0) {
    payload.id = "t0gb"
    payload.value = customT0Diff[0]
    store.dispatch(updateTimeSettingsOneByOne(payload))
  }
  if(customT0Diff.length > 1) {
    payload.id = "t0anz"
    payload.value = customT0Diff[1]
    store.dispatch(updateTimeSettingsOneByOne(payload))
  }
  if(customT0Diff.length > 2) {
    payload.id = "t0oth"
    payload.value = customT0Diff[2]
    store.dispatch(updateTimeSettingsOneByOne(payload))
  }

  payload.id = "commision"
  payload.value = info.attributes["custom:t0"].split("|")[1]
  store.dispatch(updateCommissionSetting(payload))

  payload.id = "backStake"
  payload.value = info.attributes["custom:t0"].split("|")[2]
  store.dispatch(updateBackStakeSetting(payload))

  payload.id = "layStake"
  payload.value = info.attributes["custom:t0"].split("|")[3]
  store.dispatch(updateLayStakeSetting(payload))

  if(customT0Diff.length > 0) {
    payload.id = "diffgb"
    payload.value = customT0Diff[0];    
    store.dispatch( updateT0Settings(payload))
  }
  if(customT0Diff.length > 1) {
    payload.id = "diffanz"
    payload.value = customT0Diff[1];    
    store.dispatch( updateT0Settings(payload))
  }
  if(customT0Diff.length > 2) {
    payload.id = "diffoth"
    payload.value = customT0Diff[2];    
    store.dispatch( updateT0Settings(payload))
  }

    payload.id = "t1"
    payload.value = info.attributes["custom:exact_t1"]
    store.dispatch(updateExactTimeSettingsOneByOne(payload))

    payload.id = "t2"
    payload.value = info.attributes["custom:exact_t2"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t3"
    payload.value = info.attributes["custom:exact_t3"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t4"
    payload.value = info.attributes["custom:exact_t4"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t5"
    payload.value = info.attributes["custom:exact_t5"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t6"
    payload.value = info.attributes["custom:exact_t6"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    
    let exact_t0 = info.attributes["custom:exact_t0"].split(",")
    if(exact_t0.length > 0) {
      payload.id = "t0gb"
      payload.value = exact_t0[0]
      store.dispatch(updateExactTimeSettingsOneByOne(payload))
    }
    if(exact_t0.length > 1) {
      payload.id = "t0anz"
      payload.value = exact_t0[1]
      store.dispatch(updateExactTimeSettingsOneByOne(payload))
    }
    if(exact_t0.length > 2) {
      payload.id = "t0oth"
      payload.value = exact_t0[2]
      store.dispatch(updateExactTimeSettingsOneByOne(payload))
    }

    payload.id = "t1"
    payload.value = info.attributes["custom:t1_type"]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t2"
    payload.value = info.attributes["custom:t2_type"]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t3"
    payload.value = info.attributes["custom:t3_type"]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t4"
    payload.value = info.attributes["custom:t4_type"]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t5"
    payload.value = info.attributes["custom:t5_type"]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t6"
    payload.value = info.attributes["custom:t6_type"]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    
    payload.id = "t0gb"
    let t0_types = info.attributes["custom:t0_type"].split(",");
    if(t0_types.length > 0) {
      payload.value = t0_types[0]
      store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    }
  if(t0_types.length > 1) {
    payload.id = "t0anz"
    payload.value = t0_types[1]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
  }
if(t0_types.length > 2) {
    payload.id = "t0oth"
    payload.value = t0_types[2]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
}
 if(t0_types.length > 0) {
    payload.id = "optiongb"
    payload.value = t0_types[0]
    store.dispatch( updateT0Settings(payload))
 }
  if(t0_types.length > 1) {

     payload.id = "optionanz"
    payload.value = t0_types[1]
    store.dispatch( updateT0Settings(payload))
  }
 if(t0_types.length > 2) {
    payload.id = "optionoth"
    payload.value = t0_types[2]
    store.dispatch( updateT0Settings(payload))
 }

    // load latestOddsSettings
    payload.id = "tickUntilActualStart"
    payload.value = info.attributes["custom:latestodds:mode"]
    store.dispatch(updateLatestOddsSettings(payload))

    payload.id = "noOfSeconds"
    payload.value = info.attributes["custom:latestodds:seconds"]
    store.dispatch(updateLatestOddsSettings(payload))

    //Steamer Drifter Settings
    payload.id = "STEAMER_MIN_PRICE"
    payload.value = info.attributes["custom:steamer_min_price"]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "STEAMER_MAX_PRICE"
    payload.value = info.attributes["custom:steamer_max_price"]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "DRIFTER_MIN_PRICE"
    payload.value = info.attributes["custom:drifter_min_price"]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "DRIFTER_MAX_PRICE"
    payload.value = info.attributes["custom:drifter_max_price"]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "MIN_VOLUME"
    payload.value = info.attributes["custom:min_volume"]
    store.dispatch( update_Steamer_Drifter_Settings(payload))

    //store.dispatch(updateTimeSettings(timesettings))
    }catch (e) {
    console.log("Error");
    //alert(e.message);
    }

  }
  catch(e) {
    console.log(e)
    if (e !== 'Invalid username or password.') {
      // alert(e);
    }
  }

  this.setState({ isAuthenticating: false });
}

userHasAuthenticated = (authenticated,user) => {
  this.setState({ isAuthenticated: authenticated, userName: user });
}

  render() {


    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      userName: this.state.userName
    };
    return (
      !this.state.isAuthenticating &&
      <div className="App container">
      <NotificationContainer/>    
      <Routes childProps={childProps}/>
      </div>
    );
  }
}

export default App;
